<template>
    <b-card :style="{'max-width': get_max_width(), 'width': '90%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text>
            <h4>Items To Be Picked</h4>
        </b-card-text>

        <b-card>
            <div v-if="pick_location_counts.length>0">
                <b-button variant="outline-dark" v-for="pick_location, plidx in pick_location_counts" style="margin: 5px;" @click="fetch_init(pick_location)" v-bind:key="plidx">{{ packet.locationsdict[pick_location.pick_location_id] }} ({{ pick_location.cnt }})</b-button>
            </div>

            <b-card-text style="text-align: center;">
                Please make sure <span style="background: #f2f2f2; padding: 3px;">INV/TR</span> and <span style="background: #f2f2f2; padding: 3px;">Stage for</span> label is present on each item. 
            </b-card-text>
        </b-card>

        <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
            <div v-if="items.length > 0">
                <b-card-text v-if="selected.length > 0">
                    <b-button size="sm" variant="outline-primary" @click="update_selected">Update Selected</b-button>
                </b-card-text>

                <table style="width: 100%;">
                    <thead>
                        <tr style="background: slategray; color: white;">
                            <td class="ipt_tdhr">
                                #
                            </td>
                            <td class="ipt_tdhr">
                                PULL DATE
                            </td>
                            <td class="ipt_tdhr">
                                PRD
                            </td>
                            <td class="ipt_tdhr">
                                INV/TR
                            </td>
                            <td class="ipt_tdhr">
                                STAGE FOR
                            </td>
                            <td class="ipt_tdhr">
                                ACTION
                            </td>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="item, idx in items" :style="{background: get_background(item)}" v-bind:key="idx">
                            <td class="ipt_tdr">
                                {{ idx + 1 }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.pull_date }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.product_sku }} x {{ item.quantity }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.invoice_id }}
                            </td>
                            <td class="ipt_tdr">
                                {{ item.stage_for }}
                            </td>
                            <td class="ipt_tdr">
                                <span v-if="item.picked_status == 'picked'">
                                    <b-button size="sm" variant="outline-danger" @click="undo_picked_action(item)">Undo Picked</b-button>
                                </span>
                                <span v-else-if="item.picked_status == 'cannot_be_picked'">
                                    <b-button size="sm" variant="outline-danger" @click="undo_picked_action(item)">Undo Cant Pick</b-button>
                                </span>
                                <span v-else>
                                    <b-button variant="primary" size="sm" @click="mark_picked(item)" style="margin: 3px;">Mark Picked</b-button>
                                    <b-button variant="secondary" @click="mark_cannot_be_picked(item)" size="sm" style="margin: 3px;">Cannot Pick</b-button>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <div v-else>
                <b-card-text>
                    <b-alert variant="warning" show>No Items to pick</b-alert>
                </b-card-text>
            </div>
        </b-overlay>
    </b-card>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
   
    export default {
        name: "AdminToolsItemsToBePicked",
        props: [],
        components: {Backer, flatPickr},
        data: function(){
            return {
                items: [],
                items_being_loaded: false,
                packet: {},
                all_loc_inventory_dict: {},
                global_vars: global_vars,
                selected: [],
                pull_date: null,
                pick_location_id: null,
                pick_location_counts: []
            }
        },
        methods: {
            fetch_init: function(item){
                let that = this;
                console.log(item.pick_location_id)
                let data = {pick_location_id: item.pick_location_id};
                let path = "/api/transfers/get_items_to_pick/"
                let s = function(response){
                    if (response.data.result){
                        that.items = response.data.result;
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading items to pick.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/transfers/get_pick_location_counts/",
                        data: {},
                        type: "",
                        executable: Requestor.getAsync,
                        s: function(response) {
                            if (response.data.result){
                                console.log(response.data.result)
                                that.pick_location_counts = response.data.result;
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error) {
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading pick summary.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    },
                ]

                for (var i=0; i<prereqs.length; i++){
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            undo_picked_action: function(item){
                let path = "/api/transfers/mark_single_element_no_picked_action/"
                let that = this;
                let data = {
                    tr_id: item.tr_id,
                    product_sku: item.product_sku
                }
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Undo Pick Success.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        // delete item["picked_status"]
                        // delete item["picked_by"]
                        // delete item["picked_ts"]
                        item.picked_status = null
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            mark_cannot_be_picked: function(item){
                let path = "/api/transfers/mark_single_element_cannot_be_picked/"
                let that = this;
                let data = {
                    picked_by: this.packet.userDetails.username,
                    picked_ts: moment().format("MM-DD-YYYY HH:mm"),
                    picked_status: "cannot_be_picked",
                    tr_id: item.tr_id,
                    product_sku: item.product_sku
                }
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Marked as cannot be picked.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.picked_status = "cannot_be_picked"
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }
                let f = function(error){
                    that.$bvToast.toast(
                        "Error marking item as picked. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            mark_picked: function(item){
                let path = "/api/transfers/mark_single_element_picked/"
                let that = this;
                let data = {
                    picked_by: this.packet.userDetails.username,
                    picked_ts: moment().format("MM-DD-YYYY HH:mm"),
                    picked_status: "picked",
                    tr_id: item.tr_id,
                    product_sku: item.product_sku
                }
                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Marked as picked.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.picked_status = "picked"
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error marking item as picked. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                Requestor.postAsyncP(path, data, this, s, f);
            },
            update: function(item){
                let path = "/api/transfers/update/"
                let that = this;
                let data = item;

                if (!data.stage_for){
                    this.$vex.dialog.alert({
                        message: "Please specify a staging location for the item"
                    });
                    return
                }
                if (!data.pull_date){
                    this.$vex.dialog.alert({
                        message: "Please specify a valid pull date."
                    });
                    return
                }

                // data.pull_date = moment(data.pull_date, "YYYY-MM-DD").format('YYYY-MM-DD');
                // console.log(data.pull_date)

                data.status = this.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];

                let s = function(response){
                    if (response.data.result){
                        that.$bvToast.toast(
                            "Updated.", 
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        if (data.stage_for != null){
                            item.status = that.global_vars.TRANSFER_STATUSES_REVERSE_DICT["ADDED TO PULLIST"];
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating transfer. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            compose_update: function(item){
                let approved_quantity = parseInt(item.approved_quantity);
                let status = item.status;
                let locsub = item.locsub;
                let source_location_id = null;
                let source_sublocation_id = null;
                if (locsub){
                    source_location_id = parseInt(locsub.split("|")[0])
                    source_sublocation_id = parseInt(locsub.split("|")[1])
                }

                let output = {out: {}, error: null};
                if (isNaN(approved_quantity)){
                    output.error = "Please specify a valid approved quantity."
                }
                output.out = {status: status, source_location_id: source_location_id, source_sublocation_id: source_sublocation_id, approved_quantity: approved_quantity, tr_id: item.tr_id, itemid: item.itemid}
                return output;
            },
            
            get_background: function(item){
                if (item.picked_status == 'picked'){
                    return 'rgb(230, 252, 255)'
                }
                else if (item.pulled_status == 'cannot_be_picked'){
                    return 'cornflowerblue'
                }
                else {
                    return '#E6EE9C'
                }
            },
            get_max_width: function(){
                return '1050px'
            }
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        font-size: 14px;
        background: inherit;
    }
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsItemsToBePicked.vue